(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.widget === "undefined") {
        jQuery.extend(sm.portal, { widget: {} });
    }

    // Schedule View Model  
    //  Array Model
    function StudentCourseScheduleViewModel() {
        // Array List
        this.DataList = ko.observableArray();
        this.CourseScheduleTemplate = ko.observable('');
        this.RoomText = ko.observable('Room');

        sm.portal.vm.custom.setCustomLocalizeKey(this);
        // List Item
        this.DataItem = function () {
            this.ID = ko.observable();
            this.CourseID = ko.observable();
            this.CourseTitle = ko.observable();
            this.EnrollmentModeName = ko.observable();
            this.CreditHours = ko.observable();
            this.ClockHours = ko.observable();
            this.CourseOfferingID = ko.observable();

            // TODO: Schedule Pieces
            this.Schedules = ko.observableArray();
        };
        this.DataSubItem = function () {
            this.PeriodOrDateRange = ko.observable();
            this.Timing = ko.observable();
            this.RoomScheduleType = ko.observable();
            this.RoomInfo = ko.observable();
            this.DaysAndTimesInfo = ko.observable();
            this.FacultyInfo = ko.observableArray();
        };

        // Loading

        this.LoadModel = function (container, coursesAdditionalInfo) {
            var list = container; //.Payload.Schedule;

            // Clear existing data
            this.DataList.removeAll();

            if (!sm.portal.utility.isNullOrEmpty(list)) {
                // Create DataItems for each result and add to DataList
                for (var i = 0; i < list.length; i++) {

                    var listItem = list[i];
                    var newCourseModel = new this.DataItem();
                    var msgSubjectFormat = "";
                    var msgContentFormat = "";

                    newCourseModel.ID(listItem.ID)
                    newCourseModel.CourseID(listItem.CourseID);
                    newCourseModel.CourseTitle(listItem.CourseTitle);
                    newCourseModel.EnrollmentModeName(listItem.EnrollmentModeName);
                    newCourseModel.CreditHours(listItem.CreditHours);
                    newCourseModel.ClockHours(listItem.ClockHours);
                    newCourseModel.CourseOfferingID(listItem.CourseOfferingID);

                    msgSubjectFormat = "RE: {0} in {1} for {2}";

                    var courseData = {
                        listItem : listItem,
                        coursesAdditionalInfo : coursesAdditionalInfo
                    };
                    var courseScheduleData = sm.portal.vm.custom.callCustomization('LoadCourseData', courseData);

                    // TODO: Schedules
                    for (var j = 0; j < listItem.CourseSchedule.length; j++) {
                        var scheduleItem = listItem.CourseSchedule[j];
                        var newScheduleModel = new this.DataSubItem();
                        newScheduleModel.PeriodOrDateRange(scheduleItem.PeriodOrDateRange);  // TODO: Get Name
                        newScheduleModel.Timing(scheduleItem.ScheduleTiming); // TODO: Get Name
                        newScheduleModel.RoomScheduleType(scheduleItem.RoomScheduleType);

                        var courseScheduleArgs = {
                            listItem : listItem,
                            newScheduleModel : newScheduleModel,
                            courseScheduleData : courseScheduleData
                        }
                        var courseScheduleWidgetData = sm.portal.vm.custom.callCustomization('LoadCourseScheduleWidget', courseScheduleArgs);
                        if (!sm.portal.utility.isNullOrEmpty(courseScheduleWidgetData)) {
                            newScheduleModel = courseScheduleWidgetData;
                        }

                        newScheduleModel.RoomInfo(scheduleItem.RoomDetails);

                        var obj = {
                            DayAndTimeDetails: scheduleItem.DayAndTimeDetails,
                            PeriodOrDateRange: scheduleItem.PeriodOrDateRange
                        }
                        var reqFormatDate = sm.portal.vm.custom.callCustomization('DateFormat', obj);
                        if(sm.portal.utility.isNullOrEmpty(reqFormatDate)) {
                            newScheduleModel.DaysAndTimesInfo(scheduleItem.DayAndTimeDetails);
                        } else {
                            newScheduleModel.DaysAndTimesInfo(reqFormatDate);
                        }

                        for (var k = 0; k < scheduleItem.FacultyDetails.length; k++) {
                            var facultyItem = scheduleItem.FacultyDetails[k];
                            newScheduleModel.FacultyInfo.push({
                                DisplayName: ko.observable(facultyItem.DisplayName),
                                FullName: ko.observable(facultyItem.FullName),
                                PrimaryEmailAddress: ko.observable(facultyItem.PrimaryEmailAddress),
                                EmailFaculty: function (email, display) {
                                    // Set the Data

                                    var msgSubject = sm.portal.utility.formatString(msgSubjectFormat, viewModel.ContextStudent().Profile().PersonDisplayName(), scheduleItem.PeriodOrDateRange, listItem.CourseID);
                                    var newMsg = new sm.portal.vm.SendCommunicationViewModel();
                                    newMsg.DisplayName(display);
                                    newMsg.ToAddress(email);
                                    newMsg.FromAddress("TEMP");
                                    newMsg.ContextID(viewModel.ContextStudent().Profile().PersonID());
                                    newMsg.CurrentUserID(_currentPersonId);
                                    newMsg.Html("");
                                    newMsg.Subject(msgSubject);
                                    viewModel.SendCommunicationData(newMsg);

                                    // Show the new message form
                                    viewModel.ShowFacultyCommunication(true);

                                    // Now run the functions for Partial app popup
                                    sm.portal.ui.lightBox('Send Communication', jQuery('#sendFacultyCommunicationContainer'), 'mediumDialog', function () {
                                        jQuery('.smModal .smModalClose').on('click', function () {
                                            viewModel.ShowFacultyCommunication(false);
                                        });
                                    }, true);
                                }
                            });
                        }
                        newCourseModel.Schedules.push(newScheduleModel);
                    }
                    this.DataList.push(newCourseModel);
                }
            }
            this.Loaded(true);
        };
        this.Loaded = ko.observable(false);
        this.StandAlone = ko.observable(false);

        // Data Retrieval (NOTE: this could be handled via the parent view model, but this is here as a stand-alone)
        this.GetModelData = function (studentID, goalID) {

            var url = _baseApiUri + 'api/student360/getprofilesection/?sec=schedules&studentid=' + studentID + '&goalid=' + goalID;
            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                    if (data.Status == 'success') {
                        self.LoadModel(container);
                    }
                    sm.portal.ui.readyPage();
                },
                error: function (jqXHR, exception) {

                    var statusText = jqXHR.statusText;
                    var responseMsg = sm.portal.utility.getResourceValue('UnknownError');
                    if (jqXHR != null && jqXHR.responseText != null) {
                        responseMsg = jQuery.parseJSON(jqXHR.responseText).Message;
                    }
                    var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);
                    try {
                        viewModel.HandleError(sm.portal.utility.getResourceValue('ErrorAccessingPage'), [messageToUser]);
                    } catch (e) { }
                }
            });
        };

        var self = this;
        return self;
    };

    jQuery.extend(true, sm.portal.widget, {
        StudentCourseScheduleViewModel: StudentCourseScheduleViewModel
    });
})(jQuery);